import RGBColor from 'rgbcolor';
import _ from 'lodash';
import { TOOL_SETTING_STYLE } from '../../utilities/constants';

function _util() {
  // UUID取得
  this.getUuid = function() {
    let uuid = '',
      i,
      random;
    for (i = 0; i < 32; i++) {
      random = (Math.random() * 16) | 0;
      if (i == 8 || i == 12 || i == 16 || i == 20) {
        uuid += '-';
      }
      uuid += (i == 12 ? 4 : i == 16 ? (random & 3) | 8 : random).toString(16);
    }
    return uuid;
  };

  // タイムスタンプ取得
  this.getTimeStamp = function() {
    return new Date().getTime();
  };

  // 日付フォーマット変換
  this.dataFormat = function(date, format) {
    var w = ['日', '月', '火', '水', '木', '金', '土'];
    if (!format) {
      format = 'YYYY-MM-DD hh:mm:ss.SSS';
    }
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, `0${date.getMonth() + 1}`.slice(-2));
    format = format.replace(/DD/g, `0${date.getDate()}`.slice(-2));
    format = format.replace(/M/g, date.getMonth() + 1);
    format = format.replace(/D/g, date.getDate());
    format = format.replace(/hh/g, `0${date.getHours()}`.slice(-2));
    format = format.replace(/mm/g, `0${date.getMinutes()}`.slice(-2));
    format = format.replace(/ss/g, `0${date.getSeconds()}`.slice(-2));
    format = format.replace(/WW/g, w[date.getDay()]);
    if (format.match(/S/g)) {
      var milliSeconds = `00${date.getMilliseconds()}`.slice(-3);
      var length = format.match(/S/g).length;
      for (var i = 0; i < length; i++) {
        format = format.replace(/S/, milliSeconds.substring(i, i + 1));
      }
    }
    return format;
  };

  // ルームID取得
  this.getRoomId = function(place_id, date) {
    var dt = this.dataFormat(date, 'YYYYMMDD');
    return `${place_id}-${dt}`;
  };

  // デバイス情報取得
  this.getDevice = function() {
    var ua = navigator.userAgent;
    if (
      ua.indexOf('iPhone') > 0 ||
      ua.indexOf('iPod') > 0 ||
      (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
    ) {
      return 'sp';
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      return 'tab';
    } else {
      return 'other';
    }
  };

  // スマホか
  this.checkIsSmartphone = function() {
    if (
      navigator.userAgent
        .toLowerCase()
        .match(
          /(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini)/i
        )
    ) {
      return true;
    }
    return false;
  };

  /**
   * 左表示位置までのオフセット
   */
  this.getLeftOffset = function() {
    const CANVAS_DEFAULT_WIDTH = 1000;
    const MAIN_MENU_WIDTH = 210;
    const SUB_MENU_WIDTH = 210;
    return window.innerWidth <=
      CANVAS_DEFAULT_WIDTH + MAIN_MENU_WIDTH + SUB_MENU_WIDTH
      ? 0
      : (window.innerWidth -
          (CANVAS_DEFAULT_WIDTH + MAIN_MENU_WIDTH + SUB_MENU_WIDTH)) /
          2;
    /**
     * Canvasの初期サイズ + メインメニュー + サブメニュー
     * Windowサイズがこれらを超えている場合はオフセット値を指定する
     * 描画される背景用紙を表す白い枠の横のグレーの幅になる
     */
  };

  this.toDataURL = function(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  };

  /**
   * 今日、あるいは、指定日数前後の日付オブジェクトを得る。
   * @param {Object} [param]                      パラメータ
   * @param {Date}   [param.theDay = new Date()]  元にする日 デフォルトは今日
   * @param {number} [param.after = 0]            追加する日数
   * @description
   *  名前付き引数としてのパラメータに
   *  { theDay: 元にする日, after: 数値 } と値を渡すことで
   *  ある日を指定して前後の日を取得することができる
   * 使用例:
   *    util.getDay();            今日
   *    util.getDay({after: 1});  明日
   *    util.getDay({after: -1}); 昨日
   */
  this.getDay = function({ theDay = new Date(), after = 0 }) {
    const result = new Date(theDay.getTime());
    result.setDate(result.getDate() + after);
    return result;
  };
}

export const isInternetExplorer = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0;
};

// パス文字列で指定した深い階層にあるオブジェクトに安全にアクセスする関数
// そのプロパティが存在しなければ例外ではなく、undefined を返す。
export const getProperty = (object, propertyPath) => {
  if (!object) {
    return undefined;
  }

  let result = object;
  const propertyArray = propertyPath.split('.');
  for (let i = 0; i <= propertyArray.length - 1; i += 1) {
    if (propertyArray[i] === '') {
      return undefined;
    }
    if (typeof result[propertyArray[i]] === 'undefined') {
      return undefined;
    }
    result = result[propertyArray[i]];
  }
  return result;
};

/**
 * 例外を返さない JSON.parse
 * @param {*} str JSON文字列だが受信時に使用するのでnullやundefinedもありえるために型は限定しない
 * @return { parseResult: {String|Object}, errorMessage: {String=} }
 *  JSON.parse の例外をとらえるためにこの関数を作成した。
 */
export const jsonParse = str => {
  try {
    return {
      parseResult: JSON.parse(str),
    };
  } catch (e) {
    return {
      parseResult: 'Error',
      parseErrorMessage: `Error:JSON.parse:${str}:${e}`,
    };
  }
};

/**
 * console.error を出力する関数。
 * @param  {...any} message
 *  console.error('Error', を付属して後は任意個数の引数を受け取る
 *  処理共通化を行うために実装。
 */
export const logError = (...message) => {
  console.error('Error', ...message);
};

const convertToRGB = colorString => {
  if (_.includes(colorString, 'rgba')) {
    const [r, g, b, a] = colorString
      .slice(colorString.indexOf('(') + 1, colorString.indexOf(')'))
      .split(',');
    const result = new RGBColor(`rgb(${r},${g},${b})`);
    result.alpha = parseFloat(a);
    return result;
  }
  return new RGBColor(colorString);
};

export const getColorUpdate = (
  newColorStr,
  currentColorStr,
  isChangeAlphaOnly
) => {
  const newColor = convertToRGB(newColorStr);
  const currentColor = convertToRGB(currentColorStr);
  if (isChangeAlphaOnly) {
    // only change alpha, keep current color.
    currentColor.alpha = newColor.alpha;
    return currentColor.toRGBA();
  } else {
    if (newColor.alpha === 0) {
      // if change to transparent, do nothing with new color
    } else {
      newColor.alpha = currentColor.alpha || 1;
    }
    return newColor.toRGBA();
  }
};

export const isEnableToolStyle = (tool, objectType) => {
  return _.includes(TOOL_SETTING_STYLE[tool], objectType);
};

export const findSectorPointByAngle = (centerPoint, point1, angle) => {
  const radius = Math.sqrt(
    Math.pow(point1[0] - centerPoint[0], 2) +
      Math.pow(point1[1] - centerPoint[1], 2)
  );

  const startAngle = Math.atan2(
    point1[1] - centerPoint[1],
    point1[0] - centerPoint[0]
  );
  const endAngle = startAngle + angle;
  const x = centerPoint[0] + radius * Math.cos(endAngle);
  const y = centerPoint[1] + radius * Math.sin(endAngle);

  return [x, y];
};

export const intersectionPointOfCircleAndLine = (a, b, R, x1, y1) => {
  const delta_x = x1 - a;
  const delta_y = y1 - b;
  const t = Math.sqrt((R * R) / (delta_x * delta_x + delta_y * delta_y));

  const x2 = a + t * delta_x;
  const y2 = b + t * delta_y;
  const x3 = a - t * delta_x;
  const y3 = b - t * delta_y;

  return [x2, y2, x3, y3];
};

export const util = new _util();



// WEBPACK FOOTER //
// ./src/canvas/common/util.js